import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable max-lines */
// @ts-nocheck
import React, { PureComponent, useState, useEffect, useRef, useCallback, memo } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { StylesProvider, StyleSheet } from '@rexlabs/styling';
import { TextInput } from '@rexlabs/text-input';
import Tether from '@rexlabs/tether';
import DayPickerSingleDateController from './components/day-picker-single-date-controller';
import isInclusivelyAfterDay from './utils/isInclusivelyAfterDay';
import isValidDateX from './utils/isValidDate';
import formatDateValueX from './utils/formatDateValue';
import { DEFAULT_DISPLAY_FORMAT, SUPPORTED_DATE_FORMATS } from './constants';
var baseProps = {
  isOutsideRange: function isOutsideRange(day) {
    return !isInclusivelyAfterDay(day, moment());
  },
  hideKeyboardShortcutsPanel: true,
  numberOfMonths: 1
};
var overrides = {
  Tether: StyleSheet({
    wrapContent: {
      zIndex: 9000
    }
  })
};

var Calendar = /*#__PURE__*/function (_PureComponent) {
  _inherits(Calendar, _PureComponent);

  var _super = _createSuper(Calendar);

  function Calendar(props) {
    var _this;

    _classCallCheck(this, Calendar);

    _this = _super.call(this, props);
    var colorPrimary = props.colorPrimary,
        colorPrimaryLight = props.colorPrimaryLight,
        colorPrimaryDark = props.colorPrimaryDark;
    _this.calendarComponents = {
      CalendarDay: StyleSheet({
        afterHoveredStart: {
          backgroundColor: colorPrimaryLight,
          borderColor: colorPrimaryLight,
          ':active': {
            backgroundColor: colorPrimaryLight
          }
        },
        hoveredSpan: {
          backgroundColor: colorPrimaryLight,
          borderColor: colorPrimaryLight,
          ':active': {
            backgroundColor: colorPrimaryLight
          }
        },
        highlightedCalendar: {
          borderColor: colorPrimaryLight,
          ':active': {
            borderColor: colorPrimaryLight
          }
        },
        today: {
          borderColor: colorPrimaryDark
        },
        lastInRange: {
          borderRightColor: colorPrimaryLight
        },
        blockedMinimumNights: {
          backgroundColor: colorPrimaryLight,
          borderColor: colorPrimaryLight,
          ':active': {
            backgroundColor: colorPrimaryLight
          }
        },
        selectedSpan: {
          backgroundColor: colorPrimary,
          borderColor: colorPrimary,
          ':active': {
            backgroundColor: colorPrimaryLight
          }
        },
        selected: {
          backgroundColor: colorPrimaryDark,
          borderColor: colorPrimaryDark,
          ':active': {
            backgroundColor: colorPrimaryDark
          }
        },
        selectedStart: {
          backgroundColor: colorPrimaryDark,
          borderColor: colorPrimaryDark,
          ':active': {
            backgroundColor: colorPrimaryDark
          }
        },
        selectedEnd: {
          backgroundColor: colorPrimaryDark,
          borderColor: colorPrimaryDark,
          ':active': {
            backgroundColor: colorPrimaryDark
          }
        }
      }),
      DayPickerKeyboardShortcuts: StyleSheet({
        topLeft: {
          borderLeftColor: colorPrimary,
          ':hover': {
            borderLeftColor: colorPrimaryDark
          }
        },
        topRight: {
          borderRightColor: colorPrimary,
          ':hover': {
            borderRightColor: colorPrimaryDark
          }
        },
        bottomRight: {
          borderRightColor: colorPrimary,
          ':hover': {
            borderRightColor: colorPrimaryDark
          }
        }
      }),
      DayPickerNavigation: StyleSheet({
        prev: {
          ':focus': {
            borderColor: colorPrimary,
            boxShadow: "0 0 5px ".concat(colorPrimary)
          },
          ':active': {
            borderColor: colorPrimary,
            boxShadow: "0 0 5px ".concat(colorPrimary)
          }
        },
        next: {
          ':focus': {
            borderColor: colorPrimary,
            boxShadow: "0 0 5px ".concat(colorPrimary)
          },
          ':active': {
            borderColor: colorPrimary,
            boxShadow: "0 0 5px ".concat(colorPrimary)
          }
        }
      })
    };
    return _this;
  }

  _createClass(Calendar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          colorPrimary = _this$props.colorPrimary,
          colorPrimaryLight = _this$props.colorPrimaryLight,
          colorPrimaryDark = _this$props.colorPrimaryDark,
          props = _objectWithoutProperties(_this$props, ["colorPrimary", "colorPrimaryLight", "colorPrimaryDark"]);

      return /*#__PURE__*/React.createElement(StylesProvider, {
        key: 'calendar',
        components: this.calendarComponents
      }, /*#__PURE__*/React.createElement(DayPickerSingleDateController, _extends({}, baseProps, props)));
    }
  }]);

  return Calendar;
}(PureComponent);

function DateInput(_ref) {
  var _ref$displayFormat = _ref.displayFormat,
      displayFormat = _ref$displayFormat === void 0 ? DEFAULT_DISPLAY_FORMAT : _ref$displayFormat,
      _ref$supportedFormats = _ref.supportedFormats,
      supportedFormats = _ref$supportedFormats === void 0 ? SUPPORTED_DATE_FORMATS : _ref$supportedFormats,
      _ref$onFocus = _ref.onFocus,
      onFocusProp = _ref$onFocus === void 0 ? _.noop : _ref$onFocus,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? _.noop : _ref$onChange,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? _.noop : _ref$onBlur,
      value = _ref.value,
      daySize = _ref.daySize,
      _ref$colorPrimary = _ref.colorPrimary,
      colorPrimary = _ref$colorPrimary === void 0 ? 'turquoise' : _ref$colorPrimary,
      _ref$colorPrimaryLigh = _ref.colorPrimaryLight,
      colorPrimaryLight = _ref$colorPrimaryLigh === void 0 ? 'paleturquoise' : _ref$colorPrimaryLigh,
      _ref$colorPrimaryDark = _ref.colorPrimaryDark,
      colorPrimaryDark = _ref$colorPrimaryDark === void 0 ? 'darkturquoise' : _ref$colorPrimaryDark,
      colorText = _ref.colorText,
      _ref$navPrev = _ref.navPrev,
      navPrev = _ref$navPrev === void 0 ? 'Prev' : _ref$navPrev,
      _ref$navNext = _ref.navNext,
      navNext = _ref$navNext === void 0 ? 'Next' : _ref$navNext,
      _ref$keyboardShortcut = _ref.keyboardShortcutsCloseButton,
      keyboardShortcutsCloseButton = _ref$keyboardShortcut === void 0 ? '&times;' : _ref$keyboardShortcut,
      isOutsideRange = _ref.isOutsideRange,
      children = _ref.children,
      enableOutsideDays = _ref.enableOutsideDays,
      weekDayFormat = _ref.weekDayFormat,
      renderWeekDay = _ref.renderWeekDay,
      padding = _ref.padding,
      monthPadding = _ref.monthPadding,
      paddingBottom = _ref.paddingBottom,
      props = _objectWithoutProperties(_ref, ["displayFormat", "supportedFormats", "onFocus", "onChange", "onBlur", "value", "daySize", "colorPrimary", "colorPrimaryLight", "colorPrimaryDark", "colorText", "navPrev", "navNext", "keyboardShortcutsCloseButton", "isOutsideRange", "children", "enableOutsideDays", "weekDayFormat", "renderWeekDay", "padding", "monthPadding", "paddingBottom"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      onFocusChange = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      displayValue = _useState4[0],
      updateDisplayValue = _useState4[1];

  var formatDateValue = useCallback(function (value) {
    // This will format a given moment date object to the format
    // we want it to have in the display, not the actual form field
    // value! If the `value` is not a moment object, we don't want
    // to set it to anything here
    return formatDateValueX(value, displayFormat);
  }, [displayFormat]);
  var isValidDate = useCallback(function (value) {
    var _context;

    // This is used for manually entered dates, only if they match one of
    // the defined suppported formats we will actually accept that value
    return isValidDateX(value, _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(supportedFormats), [displayFormat]));
  }, [displayFormat, supportedFormats]);

  function onFocus(e) {
    onFocusChange(true);
    onFocusProp(e);
  } // onDateChange is triggered when a date is selected via the Calendar


  var onDateChange = useCallback(function (date) {
    onChange({
      target: {
        value: moment(date)
      },
      persist: function persist() {}
    });
    onBlur();
    updateDisplayValue(formatDateValue(date));
  }, [formatDateValue, onBlur, onChange]); // onInputChange is triggered whenever the user changes the TextInput
  // of the DateInput manually

  function onInputChange(e) {
    // updateDisplayValue(e.target.value);
    var date = isValidDate(e.target.value);

    if (date && date.isValid()) {
      // if whatever the user typed in is a valid date, we want to change
      // the `value` (NOT the displayValue, cause they might not be finished
      // and setting the display value will format and shift the cursor!
      // e.g. 2020/1/1 is a valid date, but maybe the user wanted to type
      // in 2020/1/12 :/
      onChange({
        target: {
          value: date
        },
        persist: function persist() {}
      });
    }
  }

  var onOutsideClick = useCallback(function (e) {
    onFocusChange(false);
    onBlur(e);
  }, [onBlur]);

  function onInputBlur(e) {
    if (!focus) {
      // Whenever the input is blurred we want to run a proper `onDateChange`
      // if the current input value is a valid date ... this will change the
      // displayValue properly, the actual field value would have been changed
      // in the `onInputChange` handler already :)
      var _date = isValidDate(displayValue);

      onDateChange(_date);
      onBlur(e);
    } else {
      // HACK: if the element was focused, we want to check whether the new focused
      // element is the calendar itself (or within it), if not we can assume the user
      // tabed out of the input, so we want to close the calendar
      // Timout is needed because the blur happens before the focus of the next
      // element happens :/
      _setTimeout(function () {
        var _calendarRef$current, _calendarRef$current$;

        if (!(calendarRef === null || calendarRef === void 0 ? void 0 : (_calendarRef$current = calendarRef.current) === null || _calendarRef$current === void 0 ? void 0 : (_calendarRef$current$ = _calendarRef$current.contains) === null || _calendarRef$current$ === void 0 ? void 0 : _calendarRef$current$.call(_calendarRef$current, window.document.activeElement))) {
          var _date2 = isValidDate(displayValue);

          onFocusChange(false);
          onDateChange(_date2);
          onBlur(e);
        }
      }, 0);
    }
  }

  useEffect(function () {
    var date = isValidDate(value);

    if (date !== value) {
      onDateChange(isValidDate(formatDateValue(value)));
    }
  }, // eslint-disable-next-line
  []);
  useEffect(function () {
    if (!focused) {
      updateDisplayValue(formatDateValue(value));
    }
  }, // eslint-disable-next-line
  [value, focused]);
  var inputRef = useRef();
  var calendarRef = useRef();
  var Content = useCallback(function () {
    return /*#__PURE__*/React.createElement("div", {
      ref: calendarRef
    }, /*#__PURE__*/React.createElement(Calendar, {
      key: "calendar",
      date: isValidDate(value),
      daySize: daySize,
      colorPrimary: colorPrimary,
      colorPrimaryLight: colorPrimaryLight,
      colorPrimaryDark: colorPrimaryDark,
      colorText: colorText,
      navPrev: navPrev,
      navNext: navNext,
      keyboardShortcutsCloseButton: keyboardShortcutsCloseButton,
      focused: focused,
      onFocusChange: onFocusChange,
      onDateChange: onDateChange,
      onOutsideClick: onOutsideClick,
      isOutsideRange: isOutsideRange,
      enableOutsideDays: enableOutsideDays,
      weekDayFormat: weekDayFormat,
      renderWeekDay: renderWeekDay,
      padding: padding,
      monthPadding: monthPadding,
      paddingBottom: paddingBottom
    }));
  }, [colorPrimary, colorPrimaryDark, colorPrimaryLight, colorText, daySize, enableOutsideDays, focused, isOutsideRange, isValidDate, keyboardShortcutsCloseButton, monthPadding, navNext, navPrev, onDateChange, onOutsideClick, padding, paddingBottom, renderWeekDay, value, weekDayFormat]);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    components: overrides
  }, !!focused && /*#__PURE__*/React.createElement(Tether, {
    distance: 0,
    placement: 'bottom-start',
    Content: Content,
    Arrow: function Arrow() {
      return null;
    },
    referenceElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
  }), /*#__PURE__*/React.createElement("div", {
    ref: inputRef
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, props, {
    onFocus: onFocus,
    type: "text",
    value: displayValue // Overriding the event handlers of the TextInput, see comments
    // within the handlers above
    ,
    onChange: onInputChange,
    onBlur: onInputBlur,
    isValidDate: isValidDate
  }))));
}

export default /*#__PURE__*/memo(DateInput);